// import React, { useEffect, useState } from "react";
// import Autocomplete from "@mui/material/Autocomplete";
// import { FormControl, TextField, Box, Typography } from "@mui/material";
// import { useSelector } from "react-redux";

// const Genre = ({ label, formik, id, csvData }) => {
//   const genres = useSelector((state) => state.contentForm.genres);
//   const OMDbContent = useSelector((state) => state.apiContent.OMDbContent);
//   const [selectedGenres, setSelectedGenres] = useState(formik.values.genre);

//   const handleSelectedGenres = (genre) => {
//     const genresArray = genre.split(",").map((genre) => genre.trim());
//     const filteredGenres = genresArray.filter((genre) =>
//       genres.includes(genre)
//     );
//     setSelectedGenres(filteredGenres);
//     formik.setFieldValue("genre", filteredGenres);
//   };

//   useEffect(() => {
//     if (OMDbContent?.Genre) {
//       handleSelectedGenres(OMDbContent?.Genre);
//     } else if (csvData[0]?.Genre) {
//       handleSelectedGenres(csvData[0]?.Genre);
//     } else {
//       return;
//     }
//   }, [OMDbContent, genres]);

//   useEffect(() => {
//     setSelectedGenres(formik.values.genre);
//   }, [formik.values.genre]);

//   console.log(selectedGenres, "selectedGenres");

//   return (
//     <>
//       <FormControl sx={{ width: "100%" }} variant="standard">
//         <label style={{ margin: "10px 0" }} htmlFor={id}>
//           {label}
//         </label>
//         <Box
//           component={"div"}
//           sx={{
//             position: "relative",
//           }}
//         >
//           <Autocomplete
//             disablePortal
//             id={id}
//             multiple
//             size="large"
//             options={genres}
//             value={selectedGenres || []}
//             onChange={(event, newValue) => {
//               setSelectedGenres(newValue);
//               formik.setFieldValue("genre", newValue);
//             }}
//             style={{ width: "100%" }}
//             fullWidth
//             renderInput={(params) => <TextField fullWidth {...params} />}
//           />
//         </Box>
//       </FormControl>
//       {formik.touched.genre && formik.errors.genre && (
//         <Typography sx={{ color: "red" }}>{formik.errors.genre}</Typography>
//       )}
//     </>
//   );
// };

// export default Genre;

import React, { useEffect, useState } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { FormControl, TextField, Box, Typography } from "@mui/material";
import { useSelector } from "react-redux";

const Genre = ({ label, formik, id, csvData }) => {
    const genres = useSelector((state) => state.contentForm.genres);
    const OMDbContent = useSelector((state) => state.apiContent.OMDbContent);
    const [selectedGenres, setSelectedGenres] = useState(formik.values.genre);

    const handleSelectedGenres = (genre) => {
        const genresArray = genre?.split(",").map((genre) => genre.trim());
        const filteredGenres = genresArray.filter((genre) =>
            genres.includes(genre)
        );
        setSelectedGenres(filteredGenres);
        formik.setFieldValue("genre", filteredGenres);
    };

    useEffect(() => {
        if (OMDbContent?.Genre) {
            handleSelectedGenres(OMDbContent?.Genre);
        } else if (csvData?.genre?.value) {
            handleSelectedGenres(csvData?.genre[0]?.value);
        } else {
            return;
        }
    }, [OMDbContent, genres]);

    useEffect(() => {
        setSelectedGenres(formik.values.genre);
    }, [formik.values.genre]);

    console.log(selectedGenres, "selectedGenres");

    return (
        <>
            <FormControl sx={{ width: "100%" }} variant="standard">
                <label style={{ margin: "10px 0" }} htmlFor={id}>
                    {label}
                </label>
                <Box
                    component={"div"}
                    sx={{
                        position: "relative",
                    }}
                >
                    <Autocomplete
                        disablePortal
                        id={id}
                        multiple
                        size="large"
                        options={genres}
                        value={selectedGenres || []}
                        onChange={(event, newValue) => {
                            setSelectedGenres(newValue);
                            formik.setFieldValue("genre", newValue);
                        }}
                        style={{ width: "100%" }}
                        fullWidth
                        renderInput={(params) => (
                            <TextField fullWidth {...params} />
                        )}
                    />
                </Box>
            </FormControl>
            {formik.touched.genre && formik.errors.genre && (
                <Typography sx={{ color: "red" }}>
                    {formik.errors.genre}
                </Typography>
            )}
        </>
    );
};

export default Genre;
